<template>
  <div class="ssr_contact">
    <div>
      <Tooltip placement="left" max-width="180">
        <div class="middle">
          <div class="tc">
            <i class="iconfont icon-zixu"></i>
            <p>在线客服</p>
          </div>
        </div>
        <div class="contact-list" slot="content">
          <div class="contact-item">
            <div class="iconfont icon-telephone f"></div>
            <div class="content">
              <p class="f">咨询电话</p>
              <p class="f">400-998-0137</p>
            </div>
          </div>
          <div class="contact-item cursor" id="zaixiankefu">
            <div class="iconfont icon-kefu1 f"></div>
            <a
              href="https://b.zhulogic.com/collect/collectImages/chat.html"
              target="_blank"
            >
              <div class="content f">在线客服</div>
            </a>
          </div>
        </div>
      </Tooltip>
    </div>
    <div>
      <Tooltip placement="left" max-width="180">
        <router-link to="/download">
          <div class="middle">
            <div class="tc">
              <i class="iconfont icon-shouji"></i>
              <p>下载APP</p>
            </div>
          </div>
        </router-link>

        <div slot="content">
          <img
            src="https://oss.zhulogic.com/inspirationImage/lgy/tRZMxbrShjNMejiwDsM3TJsmcPbKPKfwnH.png"
            style="width: 140px"
            alt
          />
          <p class="f">住逻辑APP下载</p>
          <p class="txt f">让好设计完美落地</p>
        </div>
      </Tooltip>
    </div>
    <BackTop style="z-index: 9500" :height="500" :right="0" :bottom="25">
      <div class="middle">
        <div class="back-top">
          <i class="iconfont icon-dingbu"></i>
          <p>返回顶部</p>
        </div>
      </div>
    </BackTop>
  </div>
</template>
<script>
export default {
  created() {
    // this.$store.dispatch("getUserInfo");
  },
  methods: {
    handleClickKefu() {
      window.open(
        `https://chat.aiheconglinkb.com/chat/h5/chatLink.html?channelId=M1a0Um`
      );
      // console.log("phone", this.$store.state.userInfo.phone);
      // _AIHECONG("showChat");
      // _AIHECONG("customer", {
      //   手机: this.$store.state.userInfo.phone,
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
.contact-list {
  padding-bottom: 15px;
  white-space: normal;
  .contact-item {
    display: flex !important;
    align-items: center;
    color: #b2b2b2;
    padding-top: 15px;
    .iconfont {
      padding-right: 8px;
      font-size: 18px;
      width: 40px;
      display: block;
      text-align: right;
    }
    .content {
      font-size: 12px;
      font-weight: 500;
      color: #777777;
      line-height: 12px;
      text-align: left;
      padding-left: 8px;
      width: 98px;
      p {
        text-align: left !important;
        color: #777777;
      }
      p ~ p {
        margin-top: 8px;
      }
    }
  }
}
.tc {
  text-align: center;
}
.f {
  color: #fff;
}
.contact-list .contact-item .content p {
  color: #fff;
}
.contact-list .contact-item .content {
  color: #fff;
}
.ssr_contact {
  position: fixed;

  right: 0;
  bottom: 100px;
  z-index: 99999;
  box-shadow: 0 7px 13px -9px #171616;
  background-color: #fff;
  .middle {
    width: 72px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: #fff;
    i {
      color: #b2b2b2;
      font-size: 25px;
    }
    p {
      font-size: 12px;
      color: #b2b2b2;
    }
    &:hover {
      background: #f3f3f3;
      i,
      p {
        color: #868686;
      }
    }
  }
}
</style>